import React from "react";
import Active from "./home/active"
import { NavLink } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';


const WorkOrder = () => {
  
    return (
        <>
          
<div className="row pb-2 pt-3 m-0   start-0  my-2 ">
                <div className="col-md-5 col-sm-12 ps-3 ">
                    <h3 className="text-dark my-0">ACTIVE ORDERS</h3>
                </div>
                <div className="col-md-7 col-sm-12 ps-3 text-end">
                <div className="container-fluid z-2  ">

                <span className="btn btn-success rounded-0 me-1">
                    <HashLink className="nav-link" smooth to="/client/home">
                        ACTIVE WORK ORDERS
                    </HashLink>
                </span>
                <span className="btn btn-warning rounded-0  me-1 ">
                    <NavLink className="nav-link" smooth to="/client/work-orders-records-obtained">
                        RECORDS OBTAINED
                    </NavLink>
                </span>

                <span className="btn btn-warning rounded-0  me-1 ">
                    <NavLink className="nav-link" smooth to="/client/work-orders-closed">
                        CLOSED
                    </NavLink>
                </span>

                <span className="btn btn-warning rounded-0  ">
                    <NavLink className="nav-link" smooth to="/client/work-orders-incomplete">
                        INCOMPLETE
                    </NavLink>
                </span>
            </div>
            </div>
            </div>

            <div className="row p-1 " id="open">

<div className="col-12" >
    <Active />

</div>

</div>

            {/* BEGIN OPEN WORK ORDERS - PENDING OPEN ACTION 

            <div className="row p-1 " id="open">

                <div className="col-12" >
                    <Open />

                </div>

            </div>
            */}
            {/* END OPEN WORK ORDERS - PENDING OPEN ACTION */}

            




            {/* BEGIN OPEN WORK ORDERS - PENDING FACILITY ASSIGNMENT 
            <div className="row p-1" id="assign">

                <div className="col-12" >
                    <PendingFacilityAssignment />
                </div>

            </div>
             */}

            {/* END OPEN WORK ORDERS - PENDING FACILITY ASSIGNMENT  */}







            {/* BEGIN OPEN WORK ORDERS - PENDING Patient Authorization  

            <div className="row p-1" id="patient">

                <div className="col-12" >
                    <PendingPatientAuthorization />
                </div>

            </div>

            */}
            {/* END OPEN WORK ORDERS - PENDING Patient Authorization  */}



            {/* BEGIN OPEN WORK ORDERS - PENDING CLIENT/AGENT ACTION 

            <div className="row p-1" id="client" >

                <div className="col-12" >
                    <PendingClientCaseManagerAction />
                </div>

            </div>
            */}
            {/* END OPEN WORK ORDERS - PENDING CLIENT/AGENT ACTION */}




        </>


    );
};

export default WorkOrder;